import { ReactNode, useState } from "react";
import { styled, Tab, Tabs, TabsProps } from "@mui/material";

interface CustomTabsProps extends TabsProps {
    titleTabs: Array<ReactNode>;
    alias?: string;
    onChangeTab?: (titleTab: ReactNode, index: number) => void;
    tabActive: number;
}

const StyledTabs = styled(Tabs)<TabsProps>(({ theme }) => ({
    backgroundColor: theme.palette.main2.main,
    borderTopLeftRadius: "14px",
    borderTopRightRadius: "14px",
    "& .MuiButtonBase-root.MuiTab-root": {
        fontSize: "20px",
        fontWeight: 700,
        color: "#FFF",
        textTransform: "None",
        background: `linear-gradient(to top, ${theme.palette.main2.main} 0, ${theme.palette.main2.main} 25%, white 25%, white 75%, ${theme.palette.main2.main} 75%, ${theme.palette.main2.main} ) right no-repeat`,
        backgroundSize: "1px 100%",
    },
    "& .MuiButtonBase-root.MuiTab-root:has(+.Mui-selected)": {
        background: "",
        backgroundSize: "0px 100%",
    },
    "& .MuiButtonBase-root.MuiTab-root:last-of-type": {
        backgroundSize: "0px 100%",
    },
    "& .Mui-selected": {
        fontWeight: 700,
        fontSize: "20px",
        color: "#FFF",
        textTransform: "None",
        borderTopLeftRadius: "14px",
        borderTopRightRadius: "14px",
        borderRight: "0px solid orange !important",
        backgroundSize: "0px 100% !important",
        zIndex: 1,
    },
    "& .MuiTabs-indicator": {
        backgroundColor: theme.palette.main3.main,
        height: "100%",
        zIndex: 0,
        borderTopLeftRadius: "14px",
        borderTopRightRadius: "14px",
        transition: "all 0.3s ease",
    },
}));

export const TabSolicitudes = ({ titleTabs, alias, onChangeTab, tabActive }: CustomTabsProps) => {
    const [value, setValue] = useState<number>(tabActive);

    const a11yProps = (index: number) => {
        return {
            id: `simple-tab-${alias ? `${alias}-` : ""}${index}`,
            "aria-controls": `simple-tabpanel-${alias ? `${alias}-` : ""}${index}`,
        };
    };

    const handleOnChangeTab = (_: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
        onChangeTab?.(titleTabs[newValue], newValue);
    };

    return (
        <StyledTabs value={tabActive} variant="fullWidth" onChange={handleOnChangeTab}>
            {titleTabs.map((title: ReactNode, index: number) => (
                <Tab key={index} label={title} {...a11yProps(index)} />
            ))}
        </StyledTabs>
    );
};
